module.exports = __webpack_public_path__ + "static/media/SocialImage.13979954.png";